import { sound } from '@pixi/sound';
import { Container, Graphics, Sprite, Text } from 'pixi.js';
import { LOCALE_DATA } from '../constant';
import { Store, TextureFactory } from '../core';

class HomeButton extends Container {
  constructor() {
    super();

    const homeButton = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/btn_long_home.png'));
    homeButton.anchor.set(0.5);

    this.addChild(homeButton);

    let pressed: boolean = false;

    const text = new Text(LOCALE_DATA[Store.instance.state.locale].RE_PLAY_WITH_NEW_RECORD, {
      fontSize: 60,
      fontWeight: '900',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      align: 'center',
      fill: '#4a282f',
      letterSpacing: -6,
    });
    text.x = 40;
    text.y = -5;
    text.anchor.set(0.5);
    this.addChild(text);

    this.on('pointerdown', () => {
      sound.play('/audio/btn.mp3', { loop: false, volume: Store.instance.state.volume as number });
      pressed = true;
      this.scale.set(0.95);
    });

    this.on('pointerup', () => {
      if (pressed) {
        this.emit('clicked');
        this.scale.set(1);
      }
      pressed = false;
    });
    this.on('pointerupoutside', () => {
      pressed = false;
      this.scale.set(1);
    });
  }
}

class AllClearUI extends Container {
  public scoreText: Text;
  public note: Text;
  public gameState: { stage: string; score: string; rank: number } = { stage: '', score: '', rank: -1 };

  constructor() {
    super();

    const dim = new Graphics();
    dim.beginFill(0x000000, 0.7);
    dim.drawRect(-540, -960, 1080, 1920);
    dim.endFill();
    this.addChild(dim);

    const base = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/popup_all_clear.png'));
    base.anchor.set(0.5);
    this.addChild(base);

    const homeButton = new HomeButton();
    homeButton.interactive = true;
    homeButton.buttonMode = true;
    homeButton.y = 410;
    homeButton.on('clicked', () => {
      this.emit('home');
    });
    this.addChild(homeButton);

    this.scoreText = new Text('0', {
      fontSize: 90,
      fontWeight: '900',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#4a282f',
    });
    this.scoreText.anchor.set(0.5);
    this.scoreText.y = -290;
    this.addChild(this.scoreText);

    this.note = new Text(``, {
      fontSize: 45,
      align: 'center',
      fontWeight: '700',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#4a282f',
    });
    this.note.anchor.set(0.5);
    this.note.y = 260;
    this.addChild(this.note);

    if (Store.instance.state.locale === 'en-US') {
      this.note.text = `Ta-da!\nYou saved Mo, ${Store.instance.data.playername}!`;
    } else {
      this.note.text = `따란~! 모를 구해주셨군요!\n니니모 용사 ${Store.instance.data.playername}님!`;
    }
  }

  public setScore(stage: string, score: string, rank: number, playername: string): void {
    this.gameState.stage = stage;
    this.gameState.score = score;
    this.gameState.rank = rank;
    const d = Store.instance.e(
      `${this.gameState.stage},${this.gameState.score},${this.gameState.rank},${Store.instance.data.playername}`,
      '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w'
    );
    const textarea = document.getElementById('sharelink') as HTMLTextAreaElement;
    textarea.value = `https://ninimo.pinkfong.com/#/share?d=${encodeURIComponent(d)}`;
    this.scoreText.text = score;

    if (rank !== -1) {
      this.note.y = 260;

      if (Store.instance.state.locale === 'en-US') {
        this.note.text = `You are ranked #${rank}!`;
      } else {
        this.note.text = `니니모 용사 ${playername}님!\n무려 랭킹 "${rank}"등이다 니니!`;
      }
    }
  }

  public update(_elapsed: number): void {}
}

export default AllClearUI;
